const { Form } = require("mobx-react-form");

// Package Imports
import dvr from "mobx-react-form/lib/validators/DVR";
import validatorjs from "validatorjs";


// Project Imports
import formObserver from "./observers";
import setInitialDefaults from "./initialDefaults.js";
import * as Constants from 'constants/Constants'
import * as keys from './keys';
import Utils from './utils';

class BharatSavingsStarFormController extends Form {
    plugins() {
        return {
            dvr: dvr(validatorjs),
        };
    }

    setup() {
        return {
            fields: [
                {
                    name: "income",
                    label: "Income",
                    placeholder: "",
                    disabled: true,
                },
                {
                    name: "premium",
                    label: "Premium",
                    placeholder: "",
                    disabled: true,
                    extra: {
                        calculatePremium(form, data) {
                            // let premiumAmount = 0;
                            // let inputMode = Number(form.$("payment-frequency").value.id);

                            // let amount = Number(form.$("premium").value);
                            // switch (inputMode) {
                            //   case 1:
                            //     premiumAmount = "" + amount * 1;
                            //     break;
                            //   case 2:
                            //     premiumAmount = "" + amount * 2;
                            //     break;
                            //   case 3:
                            //     premiumAmount = "" + amount * 4;
                            //     break;
                            //   case 4:
                            //     premiumAmount = "" + amount * 12;
                            //     break;
                            // }
                            // Utils.updateBi(keys.PREMIUM, premiumAmount, data.data.product_id, form, data);
                        },
                    },
                },

                {
                    name: "policy-term",
                    label: "Policy Term",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: '15', id: 15 },
                            { label: '20', id: 20 },
                            { label: '25', id: 25 },
                            { label: '30', id: 30 },
                            { label: '35', id: 35 },
                            { label: '40', id: 40 },
                        ],
                    },
                },

                {
                    name: "premium-paying-term",
                    label: "Premium Paying Term",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                    },

                },


                {
                    name: "premium-paying-frequency",
                    label: "Premium Paying Frequency",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Annual', id: 1 },
                            { label: 'Semi-Annual', id: 2 },
                            { label: 'Quarterly', id: 3 },
                            { label: 'Monthly', id: 4 }
                        ],
                    },

                },

                {
                    name: "income-benefit-payout-frequency",
                    label: "Income Benefit Payout Frequency",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Annual', id: 1 },
                            { label: 'Semi-Annual', id: 2 },
                            { label: 'Quarterly', id: 3 },
                            { label: 'Monthly', id: 4 }
                        ],
                    },

                },

                {
                    name: "plan-option",
                    label: "Plan Option",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Immediate Income', id: 1 },
                            { label: 'Deferred Income', id: 2 }
                        ],
                    },

                },

                {
                    name: "premium-break-benefit",
                    label: "Premium Break Benefit",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 3 },
                            { label: 'No', id: 4 }
                        ],
                    },

                },

                {
                    name: "accrual-of-survival-benefits",
                    label: "Accrual Of Survival Benefits",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 5 },
                            { label: 'No', id: 6 }
                        ],
                    },

                },

                {
                    name: "asb-start-policy-year-(1st-opt-in)",
                    label: "Start Policy Year ( 1st Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [

                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(1, 7)
                    },

                },

                {
                    name: "asb-end-policy-year-(1st-opt-in)",
                    label: "End Policy Year ( 1st Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [

                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(1, 47)
                    },

                },

                {
                    name: "accrual-of-survival-benefits-year-2",
                    label: "Accrual Of Survival Benefits Year 2",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 87 },
                            { label: 'No', id: 88 }

                        ],
                        hide: false,
                    },
                    
                },
                
                {
                    name: "asb-start-policy-year-(2nd-opt-in)",
                    label: "Start Policy Year ( 2nd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            
                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(3, 89)
                    },
                    
                },
                
                {
                    name: "asb-end-policy-year-(2nd-opt-in)",
                    label: "End Policy Year ( 2nd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            
                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(3, 127)
                    },

                },

                {
                    name: "accrual-of-survival-benefits-year-3",
                    label: "Accrual Of Survival Benefits Year 3",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 165 },
                            { label: 'No', id: 166 }

                        ],
                        hide: false
                    },

                },

                {
                    name: "asb-start-policy-year-(3rd-opt-in)",
                    label: "Start Policy Year ( 3rd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [

                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(5, 167)
                    },

                },

                {
                    name: "asb-end-policy-year-(3rd-opt-in)",
                    label: "End Policy Year ( 3rd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [

                        ],
                        hide: false,
                        preDefinedOptList: Utils.generatePredefinedOptListForFsp(5, 203)
                    },

                },

                {
                    name: "preponement-of-future-income",
                    label: "Preponement of future income",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [

                            { label: 'Yes', id: 239 },
                            { label: 'No', id: 240 }

                        ],
                    },

                },

                {
                    name: "pfi-start-policy-year-(1st-opt-in)",
                    label: "Start Policy Year ( 1st Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(7, 241)
                    },

                },

                {
                    name: "pfi-end-policy-year-(1st-opt-in)",
                    label: "End Policy Year ( 1st Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(7, 275)
                    },

                },

                {
                    name: "preponement-year-2",
                    label: "Preponement Year 2",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 309 },
                            { label: 'No', id: 310 }
                        ],
                    },

                },

                {
                    name: "pfi-start-policy-year-(2nd-opt-in)",
                    label: "Start Policy Year ( 2nd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(8, 311)
                    },

                },

                {
                    name: "pfi-end-policy-year-(2nd-opt-in)",
                    label: "End Policy Year ( 2nd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(8, 343)
                    },

                },

                {
                    name: "preponement-year-3",
                    label: "Preponement Year 3",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 375 },
                            { label: 'No', id: 376 }

                        ],
                    },

                },

                {
                    name: "pfi-start-policy-year-(3rd-opt-in)",
                    label: "Start Policy Year ( 3rd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(9, 377)
                    },

                },

                {
                    name: "pfi-end-policy-year-(3rd-opt-in)",
                    label: "End Policy Year ( 3rd Opt In)",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [],
                        preDefinedOptList: Utils.generatePredefinedOptList(9, 408)

                    },

                },

                {
                    name: "auto-renewal-booster",
                    label: "Auto Renewal Booster",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: 'Yes', id: 439 },
                            { label: 'No', id: 440 }

                        ],
                    },

                },

                {
                    name: "sum-assured-on-death-multiple",
                    label: "Sum Assured on Death Multiple",
                    placeholder: "",
                    disabled: false,
                    value: "",
                    extra: {
                        optionList: [
                            { label: '7', id: 7 },
                            { label: '10', id: 10 }
                        ],
                    },

                },

                // Rider
                {
                    name: 'WaiverOfPremiumRider',
                    label: 'Waiver of Premium',
                    placeholder: '',
                    value: false,
                    disabled: false,
                    extra: {
                        description: Constants.WOP_RIDER_DESCRIPTION,
                        paramName: 'WaiverOfPremiumRider',
                        rider_name: 'Waiver of Premium Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('WaiverOfPremiumRider').value
                            let productId = data.data.product_id
                            let wopRiderValue = '';

                            if (!value) {
                                wopRiderValue = '1';
                            }
                            form.$('WaiverOfPremiumRider').value = !value

                            Utils.updateBi(keys.WOP_RIDER, wopRiderValue, productId, form, data)
                        }
                    }
                },
                {
                    name: 'ADB',
                    label: 'Accidental Death Benefit',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.ADB_RIDER_DESCRIPTION,
                        paramName: 'ADBRider',
                        rider_name: 'ADB Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('ADB').value
                            form.$('ADB').value = !value

                            if (form.$('ADB').value) {
                                form.$('ADB-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('ADB-dropdown').set('value', "")
                            }
                        }
                    }
                },
                {
                    name: 'ADB-dropdown',
                    label: 'Accidental Death Benefit',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getAdbList(),
                        onBlur(form, data) {
                            let value = form.$("ADB-dropdown").value
                            Utils.updateBi(keys.ADB_RIDER, value, data.data.product_id, form, data)
                        },
                    },
                },
                {
                    name: 'ATPDRider',
                    label: 'Accidental Total and Permanent Disability',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.ATPD_RIDER_DESCRIPTION,
                        paramName: 'ATPDRider',
                        rider_name: 'ATPD Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('ATPDRider').value
                            form.$('ATPDRider').value = !value

                            if (form.$('ATPDRider').value) {
                                form.$('ATPDRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('ATPDRider-dropdown').set('value', "")
                            }
                        }

                    }
                },
                {
                    name: 'ATPDRider-dropdown',
                    label: 'Accidental Total and Permanent Disability',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getAtpdList(),
                        onBlur(form, data) {
                            let value = form.$("ATPDRider-dropdown").value
                            Utils.updateBi(keys.ATPD_RIDER, value, data.data.product_id, form, data)
                        },
                    }
                },
                {
                    name: 'CriticalIllnessRider',
                    label: 'Critical Illness',
                    placeholder: '',
                    value: false,
                    extra: {
                        description: Constants.CRITICAL_ILLNESS_RIDER_DESCRIPTION,
                        paramName: 'CriticalIllnessRider',
                        rider_name: 'Critical Illness Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('CriticalIllnessRider').value
                            form.$('CriticalIllnessRider').value = !value

                            if (form.$('CriticalIllnessRider').value) {
                                form.$('CriticalIllnessRider-dropdown').set('value', Constants.RIDERS_DEFAULT_SA)
                            } else {
                                form.$('CriticalIllnessRider-dropdown').set('value', "")
                            }
                        }
                    }
                },
                {
                    name: 'CriticalIllnessRider-dropdown',
                    label: 'Critical Illness',
                    placeholder: '',
                    value: "",
                    extra: {
                        optionList: Utils.getCriticalIllnessList(),
                        onBlur(form, data) {
                            let value = form.$("CriticalIllnessRider-dropdown").value
                            Utils.updateBi(keys.Critical_ILLNESS_RIDER, value, data.data.product_id, form, data)
                        },
                    }
                },
                {
                    name: 'PayorWaiverBenefitRider',
                    label: 'Payor Waivor Benefit',
                    placeholder: '',
                    disabled:false,
                    value: false,
                    extra: {
                        description: Constants.PWB_RIDER_DESCRIPTION,
                        paramName: 'PayorWaiverBenefitRider',
                        rider_name: 'Payor Waiver Benefit Rider',
                        changeRiderStatus(form, data) {
                            let value = form.$('PayorWaiverBenefitRider').value
                            form.$('PayorWaiverBenefitRider').value = !value

                            if (form.$('PayorWaiverBenefitRider').value) {
                                form.$('PayorWaiverBenefitRider-dropdown').set('value', form.$('PayorWaiverBenefitRider-dropdown').extra.optionList[0])
                            } else {
                                form.$('PayorWaiverBenefitRider-dropdown').set('value', {})
                            }
                        }
                    }
                },
                {
                    name: 'PayorWaiverBenefitRider-dropdown',
                    label: 'Payor Waivor Benefit',
                    placeholder: '',
                    value: {},
                    extra: {
                        optionList: [
                            { id: 1, label: 'Option 1 (On Death)' },
                            { id: 2, label: 'Option 2 (CI or ATPD)' },
                            { id: 3, label: 'Option 3 (CI or ATPD or Death)' },
                        ]
                    }
                },

            ],
        };
    }

    setDefaults(data) {
        // Set forms initial default value
        setInitialDefaults(this, data.data);

        // Observer fields
        formObserver(this, data.data);
    }
}

export default BharatSavingsStarFormController;